import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

var fileService;
export default function () {
	var FileModel = Model.extend({
		className: "AdminNotesFiles",
		defaults: {
			'manualTitle': false,
		},
	});
	var FileCollection = Collection.extend({
		model: FileModel,
	});
	var FileService = ParseService.extend({
		sortBy: 'createdAt',
		itemsOnPage: 100, // load by N items, this overrides the 1k limit 'parseService.js'
		model: FileModel,
		collection: FileCollection,
		createSimpleFile:function(file, adminnoteID,xl){
			var AdminFile = Parse.Object.extend("AdminNotesFiles");
			var adminfile = new AdminFile();
			adminfile.set("File",file);
			adminfile.set('AdminNote',{__type: "Pointer", className: "AdminNotes", objectId: adminnoteID});
			adminfile.save(null, {
				success: function(adminnote) {
					xl();
				},
				error: function(adminnote, error) {
					xl();
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error("A file has an invalid file extension. Not Uploaded",'Error');
						break;
					}
				}
			});
		},
	});
	return fileService || (fileService = new FileService());
};
// only created once for application
